/*
 * @Descripttion:
 * @version:
 * @Author: wanglikun
 * @Date: 2022-10-17 10:17:48
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-11-01 09:35:11
 */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import routerBefore from './routerBefore'
import { boxManagement, searchList, systemManager, financeManager, operationManager, businessStatistics } from './route'
import { h } from 'vue'
// import { NameEnum, UrlEnum, UnionEnum } from '@jms/utils/enums/Route'
import Layout from '@jms/layout/index.vue'
const Login = () => import('@/views/login/Index.vue')
const Home = () => import('@jms/views/home/Index.vue')
const NotFound = () => import('@jms/views/notfound/Index.vue')
const NoAuth = () => import('@jms/views/noauth/Index.vue')
const DownLoadCenter = () => import('@jms/views/download/Index.vue')
const I18n = () => import('@jms/views/i18n/Index.vue')
import logo from '@jms/assets/images/logo-cn.png'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    props: {
      logo,
      title: '邻里智柜后台管理系统'
    },
    redirect: '/',
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home,
        meta: { title: '首页', requiresAuth: true, keepAlive: true }
      },
      {
        path: '/downloadCenter',
        name: 'DownLoadCenter',
        component: DownLoadCenter,
        meta: { title: '下载中心', requiresAuth: true, keepAlive: true }
      },
      {
        path: '/notFound',
        name: 'NotFound',
        component: NotFound,
        meta: { title: 'notFound', requiresAuth: true, keepAlive: true }
      },
      {
        path: '/noAuth',
        name: 'NoAuth',
        component: NoAuth,
        meta: { title: '无权限', requiresAuth: true, keepAlive: true }
      },
      {
        path: '/i18n',
        name: 'i18n',
        component: I18n,
        meta: {
          title: 'i18n',
          requiresAuth: false,
          keepAlive: false
        }
      },
      ...boxManagement,
      ...searchList,
      ...businessStatistics,
      ...financeManager,
      ...operationManager,
      ...systemManager
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录', requiresAuth: false, keepAlive: false }
  },
  {
    path: '/:w+',
    name: '*',
    redirect: '/notFound'
  }
]

const index = createRouter({
  history: createWebHistory(),
  routes
})
//路由导航
routerBefore(index)

export default index
